import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useMobileConfig } from '../../hooks/useMobileConfig';

const ALL_TABS = [
  {
    label: 'Dashboard',
    icon: 'LayoutDashboard',
    path: '/mobile-dashboard',
    screenKey: 'dashboard',
  },
  {
    label: 'Bids',
    icon: 'FileText',
    path: '/mobile-bid-management',
    screenKey: 'bid_management',
  },
  {
    label: 'Customers',
    icon: 'Users',
    path: '/mobile-customer-management',
    screenKey: 'customer_management',
  },
  {
    label: 'Install',
    icon: 'Download',
    path: '/pwa-install-instructions',
    screenKey: null, // always visible
  },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isScreenVisible } = useMobileConfig();

  const TABS = ALL_TABS?.filter(tab => tab?.screenKey === null || isScreenVisible(tab?.screenKey));

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur border-t border-border">
      <div className="flex items-stretch">
        {TABS?.map(tab => {
          const isActive = location?.pathname === tab?.path;
          return (
            <button
              key={tab?.path}
              onClick={() => navigate(tab?.path)}
              className={`flex-1 flex flex-col items-center justify-center gap-1 min-h-[56px] py-2 px-1 transition-colors relative ${
                isActive ? 'text-accent' : 'text-muted-foreground'
              }`}
            >
              {/* Active indicator bar */}
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-accent rounded-full" />
              )}
              <Icon
                name={tab?.icon}
                size={22}
                className={isActive ? 'text-accent' : 'text-muted-foreground'}
              />
              <span className={`text-[10px] font-semibold leading-none ${
                isActive ? 'text-accent' : 'text-muted-foreground'
              }`}>
                {tab?.label}
              </span>
            </button>
          );
        })}
      </div>
      {/* iOS safe area spacer */}
      <div className="h-safe-area-inset-bottom" />
    </nav>
  );
};

export default MobileBottomNav;
